import(/* webpackMode: "eager", webpackExports: ["HalfPageAd"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/Ad/HalfPageAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeaderBoardAd"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/Ad/LeaderBoardAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RectangleAd"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/Ad/RectangleAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewFilterArea"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/filter/NewFilterArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/layout/CalendarImport.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/layout/ContentHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushButton"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/PushButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/router/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/schedule/GameSchedule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyTeamButton"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/team/MyTeamButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Gtag"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/lib/gtm.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/node_modules/next/dist/client/link.js");
